import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const Wrench: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Wrench" stroke="#222222" strokeWidth="2">
          <g id="Group" transform="translate(2.000000, 2.000000)">
            <path
              d="M19.3671806,2.73147426 L16.3899216,5.70796926 L14.2913893,5.70796926 L14.2913893,3.60934281 L17.2677508,0.631950186 C15.3849061,-0.396542182 13.0622429,-0.153383899 11.4332098,1.24276495 C9.8041766,2.6389138 9.20829465,4.89706954 9.93635145,6.91526292 L0.652724726,16.1957158 C0.0897833532,16.7586825 -0.130070279,17.5792242 0.0759805639,18.348251 C0.282031407,19.1172777 0.882682702,19.7179559 1.65167492,19.924016 C2.42066713,20.1300761 3.24117206,19.9102126 3.80411343,19.347246 L13.0850474,10.062305 C15.1031502,10.7903945 17.3612046,10.1944858 18.7572908,8.5653795 C20.153377,6.93627324 20.3965244,4.61350581 19.3680782,2.73057664 L19.3671806,2.73147426 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
